export default __webpack_public_path__ + "static/media/wa.19acd8d7.png";